import agent from '../../agent';
import config from '../../../config.json';
import ServiceBase from '../../ServiceBase';
import responseHelper from '../../ResponseHelper';
import logCacheStorage from './LogCacheStorage';

const baseUrl = config.baseUrl;
const service = 'JernyGateway'.toLowerCase();
const _name = 'LogPublisher';

/**
 * Flushes buffered log entries to BE on reconnect.
 * Resolves jwt via AppContext — consistent with TemplateFetcher pattern.
 * Clears localStorage after successful POST.
 */
class LogPublisher extends ServiceBase {
    /**
     * Posts all buffered entries to BE and clears localStorage on success.
     * Skips if no entries or no jwt available.
     * @param {{ app, uid, source, method, message, ems, count, lastSeen }[]} entries
     * @returns {boolean} true if flushed successfully
     */
    publish = async (entries) => {
        try {
            if (!entries || entries.length === 0) return false;

            const jwt = this.getToken();
            if (!jwt) return false;

            const url = `${baseUrl}/${service}/logs`;

            const headers = {
                headers: {
                    Authorization: `Bearer ${jwt}`,
                    'Content-Type': 'application/json',
                },
            };

            const dto = { data: entries };
            const resp = await agent.post(url, dto, headers);

            // Negative code = HTTP error or BE failure — keep entries for next reconnect
            if (responseHelper.check(resp, 'publish', _name) < 0) return false;

            // Clear storage only after confirmed successful POST
            logCacheStorage.clear();

            return true;
        } catch (error) {
            // Silent — publisher must never crash the reconnect flow
            return false;
        }
    };
}

const logPublisher = new LogPublisher();
export default logPublisher;
